// TODO: maybe convert socket io code to promises

import _ from 'lodash'
import axios from 'axios'

import Vue from 'vue'

import store from '@/store'

import { serializer, unserializer } from '@/components/object_model.js'

import {
  platform_decrypt_string,
  encrypt_object_fields_as_strings,
} from '@/utils.js'

// *****************************************************************************

function client_encrypt_object_fields_as_strings(
  obj,
  { unencrypted_field_names = [] } = {}
) {
  const client_key = platform_decrypt_string(
    store.getters.client_encryption_key,
    'binary'
  )
  const encrypted_obj = encrypt_object_fields_as_strings(obj, client_key, {
    unencrypted_field_names,
  })
  return encrypted_obj
}

export async function subscriptions_update(to_add, to_remove) {
  // Can only be done through a socket emit
  // console.log('subscriptions_update to_add to_remove', to_add, to_remove)
  Vue.prototype.$socket.emit('subscriptions_update', { to_add, to_remove })
}

export async function generic_subscription_update(to_add, to_remove) {
  // console.log('generic_subscription_update to_add to_remove', to_add, to_remove)
  // console.log('subscriptions_update to_add to_remove', to_add, to_remove)
  Vue.prototype.$socket.emit('generic_subscription_update', {
    to_add,
    to_remove,
  })
}

// *****************************************************************************

const api = axios.create()

export default api

api.interceptors.request.use(request => {
  // Hook to log requests to server
  // console.log('Starting Request', request)
  return request
})

api.interceptors.response.use(response => {
  // Hook to log responses from server
  // console.log('Response:', response)
  return response
})

// *****************************************************************************

export async function login(user, password) {
  const obj = { login: user, password }
  const message = client_encrypt_object_fields_as_strings(obj)
  const payload = serializer.visit(message)
  let response = await api.post('/api/login', payload)
  let res = unserializer.visit(response.data)
  return res
}

export async function logout() {
  const payload = serializer.visit({})
  const response = await api.post('/api/logout', payload)
  let res = unserializer.visit(response.data)
  return res
}

// export async function admin_change_password(user_id, password) {
//   const payload = serializer.visit({ user_id, password })
//   let res = await api.post('/api/admin_change_password', payload)
//   res = unserializer.visit(res.data)
//   return res
// }

export async function change_password(user_id, old_password, new_password) {
  const obj = { user_id, old_password, new_password }
  const message = client_encrypt_object_fields_as_strings(obj, {
    unencrypted_field_names: user_clear_fields,
  })
  const payload = serializer.visit(message)
  let res = await api.post('/api/change_password', payload)
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function set_power(should_run) {
  const ndata = serializer.visit({ should_run })
  let res = await api.post('/api/platform/set_power', ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function set_project_power(project_id, should_run) {
  const ndata = serializer.visit({ should_run })
  let res = await api.post(`/api/projects/${project_id}/set_power`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function rename_project(project_id, new_name) {
  const ndata = serializer.visit({ new_name })
  let res = await api.post(`/api/projects/${project_id}/rename`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function change_project_code(project_id, new_project_code) {
  const ndata = serializer.visit({ new_project_code })
  let res = await api.post(`/api/projects/${project_id}/change_code`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function toggle_project_in_production(project_id, value) {
  const ndata = serializer.visit({ value })
  let res = await api.post(
    `/api/projects/${project_id}/toggle_in_production`,
    ndata
  )
  res = unserializer.visit(res.data)
  return res
}

export async function reboot_webserver() {
  const data = serializer.visit({ services_to_reboot: ['webserver'] })
  let res = await api.post('/api/platform/services/reboot', data)
  res = unserializer.visit(res.data)
  return res
}

export async function hardreboot() {
  const data = serializer.visit({})
  let res = await api.post('/api/platform/reboot', data)
  res = unserializer.visit(res.data)
  return res
}

export async function get_platform_status() {
  let res = await api.get('/api/platform/status')
  res = unserializer.visit(res.data)
  return res
}

export async function list_collection(collection) {
  let res = await api.get(`/api/collections/${collection}/list`)
  res = unserializer.visit(res.data)
  return res
}

export async function get_license() {
  let res = await api.get('/api/platform/license')
  res = unserializer.visit(res.data)
  return res
}

export async function get_client_id() {
  let res = await api.get('/api/platform/client_id')
  res = unserializer.visit(res.data)
  return res
}

export async function get_login_info() {
  let res = await api.get('/api/platform/login_info')
  res = unserializer.visit(res.data)
  return res
}

export async function get_system_info() {
  let res = await api.get('/api/platform/system_info')
  res = unserializer.visit(res.data)
  return res
}

export async function get_aiplatform_config() {
  let res = await api.get('/api/platform/config')
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function show_debug(commands_list) {
  let data = { commands: commands_list }
  // console.log('data :', data)
  let ndata = serializer.visit(data)
  // console.log('ndata :', ndata)
  let res = await api.post('/api/platform/debug', ndata)
  return res.data
}

// *****************************************************************************

export async function generic_create(project_id, data) {
  const ndata = serializer.visit(data)
  let res = await api.post(`/api/projects/${project_id}/generic_create`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function generic_update(project_id, data) {
  // console.log('Before generic_update serialize')
  // console.log(project_id, data)
  const ndata = serializer.visit(data)
  // console.log('After generic_update serialize')
  let res = await api.post(`/api/projects/${project_id}/generic_update`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function generic_multiupdate(project_id, data) {
  const ndata = serializer.visit(data)
  let res = await api.post(
    `/api/projects/${project_id}/generic_multiupdate`,
    ndata
  )
  res = unserializer.visit(res.data)
  return res
}

export async function generic_duplicate(project_id, guid) {
  const data = serializer.visit(guid)
  let res = await api.post(
    `/api/projects/${project_id}/generic_duplicate`,
    data
  )
  res = unserializer.visit(res.data)
  return res
}

export async function generic_delete(project_id, data_delete) {
  const data = serializer.visit(data_delete)
  let res = await api.post(`/api/projects/${project_id}/generic_delete`, data)
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function create_project(data) {
  const ndata = serializer.visit(data)
  let res = await api.post(`/api/projects/create`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function duplicate_project(project_id, guid) {
  const data = serializer.visit(guid)
  let res = await api.post(`/api/projects/${project_id}/duplicate`, data)
  res = unserializer.visit(res.data)
  return res
}

export async function delete_project(project_id) {
  const ndata = serializer.visit({})
  let res = await api.post(`/api/projects/${project_id}/delete`, ndata)
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

var user_clear_fields = [
  'user_id',
  'uid',
  'creation_dt',
  'version',
  'is_deleted',
  'global_group_id',
]

export async function create_user(data) {
  const encrypted_data = client_encrypt_object_fields_as_strings(data, {
    unencrypted_field_names: user_clear_fields,
  })
  const encrypted_payload = serializer.visit(encrypted_data)
  const response = await api.post('/api/users/create', encrypted_payload)
  let res = unserializer.visit(response.data)
  return res
}

export async function update_user(data) {
  const encrypted_data = client_encrypt_object_fields_as_strings(data, {
    unencrypted_field_names: user_clear_fields,
  })
  const encrypted_payload = serializer.visit(encrypted_data)
  let res = await api.post('/api/users/update', encrypted_payload)
  // console.log('After post ', res)
  res = unserializer.visit(res.data)
  // console.log('After after ', res)
  return res
}

export async function delete_user(data) {
  data = client_encrypt_object_fields_as_strings(data, {
    unencrypted_field_names: user_clear_fields,
  })
  const ndata = serializer.visit(data)
  let res = await api.post('/api/users/delete', ndata)
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

var database_clear_fields = [
  // 'database_id',
  'uid',
  'creation_dt',
  'version',
  'is_deleted',
  // 'dsn',
  'database_name',
]

export async function create_database_credentials(data) {
  const encrypted_data = client_encrypt_object_fields_as_strings(data, {
    unencrypted_field_names: database_clear_fields,
  })
  const encrypted_payload = serializer.visit(encrypted_data)
  const response = await api.post(
    '/api/databases_credentials/create',
    encrypted_payload
  )
  let res = unserializer.visit(response.data)
  return res
}

export async function update_database_credentials(data) {
  const encrypted_data = client_encrypt_object_fields_as_strings(data, {
    unencrypted_field_names: database_clear_fields,
  })
  const encrypted_payload = serializer.visit(encrypted_data)
  let res = await api.post(
    '/api/databases_credentials/update',
    encrypted_payload
  )
  // console.log('After post ', res)
  res = unserializer.visit(res.data)
  // console.log('After after ', res)
  return res
}

export async function delete_database_credentials(data) {
  data = client_encrypt_object_fields_as_strings(data, {
    unencrypted_field_names: database_clear_fields,
  })
  const ndata = serializer.visit(data)
  let res = await api.post('/api/databases_credentials/delete', ndata)
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function create_project_rights(project_id, data) {
  const ndata = serializer.visit(data)
  // console.log('Before create project_rigths', project_id, data)
  let res = await api.post(`/api/projects/${project_id}/rights/create`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function update_project_rights(project_id, data) {
  const ndata = serializer.visit(data)
  let res = await api.post(`/api/projects/${project_id}/rights/update`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function delete_project_rights(project_id, data) {
  const ndata = serializer.visit(data)
  let res = await api.post(`/api/projects/${project_id}/rights/delete`, ndata)
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function uploads_create(project_id, data) {
  const ndata = serializer.visit(data)
  let res = await api.post(`/api/projects/${project_id}/uploads/create`, ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function file_brick_upload_completed(
  project_id,
  brick_uid,
  token
) {
  const ndata = serializer.visit({ token: token })
  let res = await api.post(
    `/api/projects/${project_id}/${brick_uid}/uploads/completed`,
    ndata
  )
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function create_pipe_literal(project_id, literal) {
  const api_path = `/api/projects/${project_id}/pipe/literals/create`
  const data = serializer.visit(literal)
  let res = await api.put(api_path, data)
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function get_project_backups(project_id) {
  let res
  if (project_id == null) {
    res = { is_instantiated: false }
  } else {
    res = await api.get(`/api/projects/${project_id}/get_project_backups`)
  }
  res = unserializer.visit(res.data)
  return res
}

export async function get_hash_project(project_id) {
  let url = `/api/projects/${project_id}/hash`
  let res = await api.get(url)
  res = unserializer.visit(res.data)
  return res
}

// N.B PL : Probably not a get, maybe more a post
// CAG: this is a post
export async function save_project_snapshot(project_id) {
  let url = `/api/projects/${project_id}/snapshot`
  let res = await api.get(url)
  res = unserializer.visit(res.data)
  return res
}

// CAG: this is a put
export async function load_project_snapshot(project_id, snapshot_uid) {
  let url = `/api/projects/${project_id}/load/${snapshot_uid}`
  let data = { snapshot_uid }
  let res = await api.post(url, data)
  res = unserializer.visit(res.data)
  return res
}

export async function delete_project_snapshot(project_id, snapshot_uid) {
  let ndata = serializer.visit({ snapshot_uid })
  let res = await api.post(
    `/api/projects/${project_id}/delete_project_snapshot`,
    ndata
  )
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function export_project_to_token(project_id, passphrase) {
  const obj = { passphrase }
  const message = client_encrypt_object_fields_as_strings(obj)
  const payload = serializer.visit(message)
  let res = await api.put(`/api/projects/${project_id}/export`, payload)
  res = unserializer.visit(res.data)
  return res
}

export async function import_project(
  project_id,
  filename_to_import,
  passphrase
) {
  const obj = { filename_to_import, passphrase }
  const message = client_encrypt_object_fields_as_strings(obj, {
    unencrypted_field_names: ['filename_to_import'],
  })
  const payload = serializer.visit(message)
  let res = await api.post(`/api/projects/${project_id}/import`, payload)
  res = unserializer.visit(res.data)
  return res
}

export async function import_project_from_uploaded_file(
  project_id,
  token,
  passphrase
) {
  const obj = { token, passphrase }
  const message = client_encrypt_object_fields_as_strings(obj, {
    unencrypted_field_names: ['token'],
  })
  const payload = serializer.visit(message)
  let res = await api.post(
    `/api/projects/${project_id}/import_from_uploaded`,
    payload
  )
  res = unserializer.visit(res.data)
  return res
}

// export async function test_export_jsonify(uid) {
//   const ndata = serializer.visit({ uid })
//   let res = await api.post('/api/test_export_jsonify', ndata)
//   res = unserializer.visit(res.data)
//   return res
// }

export async function export_logs_to_token() {
  let payload = serializer.visit({})
  let res = await api.put(`/api/logs/export`, payload)
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function get_dummy_file_size(expected_size) {
  let res = await api.get(`/api/dummy/file/size`, {
    params: {
      expected_size: JSON.stringify(expected_size),
    },
  })
  res = unserializer.visit(res.data)
  return res
}

export async function get_dummy_file_data(expected_size, requested_slots) {
  let response = await axios.get(`/api/dummy/file/data`, {
    params: {
      expected_size: JSON.stringify(expected_size),
      requested_slots: JSON.stringify(requested_slots),
    },
    responseType: 'arraybuffer',
  })
  let res = new Uint8Array(response.data)
  return res
}

// *****************************************************************************

export async function get_file_size(project_id, uid) {
  let res = await api.get(`/api/projects/${project_id}/files/${uid}/size`)
  res = unserializer.visit(res.data)
  return res
}

export async function get_file_data(project_id, uid, requested_slots) {
  let response = await axios.get(
    `/api/projects/${project_id}/files/${uid}/data`,
    {
      params: {
        requested_slots: JSON.stringify(requested_slots),
      },
      responseType: 'arraybuffer',
    }
  )
  let res = new Uint8Array(response.data)
  return res
}

// *****************************************************************************

export async function clean_brick_poid(project_id, brick_id, poid) {
  const ndata = serializer.visit({ brick_id, poid })
  let res = await api.post(
    `/api/projects/${project_id}/clean_brick_poid`,
    ndata
  )
  res = unserializer.visit(res.data)
  return res
}

// *****************************************************************************

export async function projects_pipe_object_get(pipe_id, pipe_object_id) {
  // console.log('projects_pipe_object_get asking for ', pipe_id, pipe_object_id)
  let res
  if (pipe_id == null || pipe_object_id == null) {
    // console.log("Not calling", pipe_id, pipe_object_id)
    res = { is_instantiated: false }
  } else {
    res = await api.get(`/api/projects/${pipe_id}/pipe/${pipe_object_id}`)
    // console.log("Got raw JSON ", _.cloneDeep(res.data))
    // console.log("From Request ", _.cloneDeep(res.request))
    res = unserializer.visit(res.data)
    // console.log("Got unserialized ", res)
  }
  // console.log('projects_pipe_object_get received ', JSON.stringify(res))
  return res
}

export async function projects_pipe_object_rawget(pipe_id, pipe_object_id) {
  // console.log('projects_pipe_object_get asking for ', pipe_id, pipe_object_id)
  let res
  if (pipe_id == null || pipe_object_id == null) {
    // console.log("Not calling", pipe_id, pipe_object_id)
    res = { is_instantiated: false }
  } else {
    res = await api.get(`/api/projects/${pipe_id}/pipe/${pipe_object_id}`)
    // console.log("Got raw JSON ", _.cloneDeep(res.data))
    // console.log("From Request ", _.cloneDeep(res.request))
    // NOTE: We do not unserialize on purpose
    res = res.data
    // console.log("Got unserialized ", res)
  }
  // console.log('projects_pipe_object_get received ', JSON.stringify(res))
  return res
}

export async function get_dispatch_summary_info(pipe_id, brick_id, poid) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log("Not calling", project_id, file_id)
    res = { is_instantiated: false }
  } else {
    res = await api.get(
      `/api/projects/${pipe_id}/bricks/${brick_id}/${poid}/dispatch_summary_info`
    )
    // console.log("Got raw JSON ", _.cloneDeep(res.data))
    res = unserializer.visit(res.data)
    // console.log("Got unserialized ", res)
  }
  return res
}

export async function get_results_file_size(pipe_id, brick_id, poid) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log("Not calling", project_id, file_id)
    res = { is_instantiated: false }
  } else {
    res = await api.get(`/api/projects/${pipe_id}/results/${poid}/file_size`)
    // console.log("Got raw JSON ", _.cloneDeep(res.data))
    res = unserializer.visit(res.data)
    // console.log("Got unserialized ", res)
  }
  return res
}

// *****************************************************************************

// export async function download_result(url, unsecured_filename) {
//   let filename = secure_filename(unsecured_filename)
//   let res = await api.get(url, {
//     params: {
//       filename,
//     },
//   })
//   res = unserializer.visit(res.data)
//   return res
// }

export async function secure_filename(filename) {
  // console.log('filename : ', filename)
  let res = await api.get('/api/secure_filename', {
    params: {
      filename,
    },
  })
  // console.log('res : ', res)
  res = unserializer.visit(res.data)
  return res
}

export async function download_file(base_url, filename) {
  let secured_filename = await secure_filename(filename)
  let url = base_url + secured_filename
  let a = document.createElement('A')
  a.href = url
  a.download = url.substr(url.lastIndexOf('/') + 1)
  document.body.appendChild(a)
  try {
    a.click()
  } finally {
    document.body.removeChild(a)
  }
}

export async function save_from_token(project_id, token, filename_to_export) {
  const ndata = serializer.visit({ token, filename_to_export })
  let res = await api.post(`/api/projects/${project_id}/save_from_token`, ndata)
  res = unserializer.visit(res.data)
  return res
}

/*export async function download_file_with_passphrase(base_url, filename, passphrase) {
  let secured_filename = await secure_filename(filename)
  let url = base_url + secured_filename
  let a = document.createElement('A')
  a.download = url.substr(url.lastIndexOf('/') + 1)
  url += "/" + passphrase
  a.href = url
  document.body.appendChild(a)
  try {
    a.click()
  } finally {
    document.body.removeChild(a)
  }
}*/

// *****************************************************************************

export async function get_columnstore_listing_from_poid(project_id, poid) {
  let res
  if (project_id == null || poid == null) {
    res = { is_instantiated: false }
  } else {
    let url = `/api/projects/${project_id}/pipe/${poid}/columnstore_listing_from_poid`
    res = await api.get(url)
    res = unserializer.visit(res.data)
  }
  return res
}

export async function table_columns(project_id, table_id, metavariables_dicts) {
  let res
  // N.B PL : Is '== -1' done on purpose or should be '=== -1' ?
  if (project_id == null || table_id == null || table_id == -1) {
    // console.log('Not calling', project_id, table_id)
    res = { is_instantiated: false }
  } else {
    if (_.isUndefined(metavariables_dicts)) {
      metavariables_dicts = null
    }
    metavariables_dicts = serializer.visit(metavariables_dicts)
    // console.log(metavariables_dict)
    const params = {
      params: { payload: { metavariables_dicts } },
    }
    // console.log('params : ', params)
    let url = `/api/projects/${project_id}/pipe/${table_id}/listing`
    // console.log('url : ', url)
    res = await api.get(url, params)
    // console.log('Got raw JSON ', _.cloneDeep(res.data))
    res = unserializer.visit(res.data)
    // console.log("Got unserialized ", res)
  }
  return res
}

// N.B PL : Temprary workaround for relations dealing with only the table_name
// No need for now of metavariables_dicts : do we remove it or do we keep it ?
export async function table_columns_from_name(
  project_id,
  table_name,
  metavariables_dicts
) {
  let res
  if (project_id == null || table_name == null || table_name === '') {
    // console.log('Not calling', project_id, table_id)
    res = { is_instantiated: false }
  } else {
    if (_.isUndefined(metavariables_dicts)) {
      metavariables_dicts = null
    }
    metavariables_dicts = serializer.visit(metavariables_dicts)
    // console.log(metavariables_dict)
    const params = {
      params: { payload: { metavariables_dicts } },
    }
    // console.log(params)
    res = await api.get(
      `/api/projects/${project_id}/table/${table_name}/listing`,
      params
    )
    // console.log('Got raw JSON ', _.cloneDeep(res.data))
    res = unserializer.visit(res.data)
    // console.log("Got unserialized ", res)
  }
  return res
}

// *****************************************************************************

// export async function parents_jsons(project_id, brick_id, metavariables_dicts) {
//   let res
//   if (project_id == null || brick_id == null || brick_id == -1) {
//     res = { is_instantiated: false }
//   } else {
//     if (_.isUndefined(metavariables_dicts)) {
//       metavariables_dicts = null
//     }
//     metavariables_dicts = serializer.visit(metavariables_dicts)
//     // console.log(metavariables_dict)
//     const params = {
//       params: { payload: { metavariables_dicts } },
//     }
//     // console.log('params : ', params)
//     let url = `/api/projects/${project_id}/pipe/${brick_id}/parents_jsons`
//     // console.log('url : ', url)
//     res = await api.get(url, params)
//     // console.log('Got raw JSON ', _.cloneDeep(res.data))
//     res = unserializer.visit(res.data)
//     // console.log("Got unserialized ", res)
//   }
//   return res
// }

// *****************************************************************************

export async function get_columnstore_datav2(
  pipe_id,
  poid,
  columns,
  range,
  options
) {
  // Used by charts to get curve (ROC + probability) data

  let res
  if (pipe_id == null || poid == null) {
    // console.log("Not calling", project_id, file_id)
    res = { is_instantiated: false }
  } else {
    const params = {
      params: { payload: { columns, range, options } },
    }
    res = await api.get(
      `/api/projects/${pipe_id}/pipe/${poid}/columnstore/datav2`,
      params
    )
    // console.log("Got raw JSON ", _.cloneDeep(res.data))
    res = unserializer.visit(res.data)
    // console.log("Got unserialized ", res)
  }
  return res
}

// *****************************************************************************

// export async function get_columnstore_general_metadata(
//   pipe_id,
//   poid,
//   filter = {}
// ) {
//   let res
//   if (pipe_id == null || poid == null) {
//     // console.log("Not calling", project_id, file_id)
//     res = { is_instantiated: false }
//   } else {
//     // console.log('pipe_id | poid | filter: ', pipe_id, poid, filter)
//     const params = {
//       params: {
//         payload: { filter },
//       },
//     }
//     res = await api.get(
//       `/api/pipe/${pipe_id}/${poid}/columnstore/generalmetadata`,
//       params
//     )
//     // console.log('res : ', res)
//     // console.log("Got raw JSON ", _.cloneDeep(res.data))
//     res = unserializer.visit(res.data)
//     // console.log("Got unserialized ", res)
//   }
//   return res
// }
export async function get_columnstore_general_metadata(pipe_id, poid) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log("Not calling", project_id, file_id)
    res = { is_instantiated: false }
  } else {
    // console.log('pipe_id | poid | filter: ', pipe_id, poid, filter)
    res = await api.get(
      `/api/projects/${pipe_id}/pipe/${poid}/columnstore/generalmetadata`
    )
    // console.log('res : ', res)
    // console.log("Got raw JSON ", _.cloneDeep(res.data))
    res = unserializer.visit(res.data)
    // console.log("Got unserialized ", res)
  }
  return res
}

export async function get_columnstore_blocks_metadata(
  pipe_id,
  poid,
  blocks_indices_list,
  block_dimensions
) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log("Not calling", project_id, file_id)
    res = { is_instantiated: false }
  } else {
    // console.log('pipe_id | poid: ', pipe_id, poid)
    const params = {
      params: {
        payload: { blocks_indices_list, block_dimensions },
      },
    }
    res = await api.get(
      `/api/projects/${pipe_id}/pipe/${poid}/columnstore/blocksmetadata`,
      params
    )
    res = unserializer.visit(res.data)
  }
  return res
}

// export async function get_columnstore_blocks_data(
//   pipe_id,
//   poid,
//   blocks_coords_list,
//   block_dimensions,
//   sort,
//   filter
// ) {
//   let res
//   if (pipe_id == null || poid == null) {
//     // console.log("Not calling", project_id, file_id)
//     res = { is_instantiated: false }
//   } else {
//     const params = {
//       params: {
//         payload: { blocks_coords_list, block_dimensions, sort, filter },
//       },
//     }
//     res = await api.get(
//       `/api/pipe/${pipe_id}/${poid}/columnstore/blocksdata`,
//       params
//     )
//     // console.log("Got raw JSON ", _.cloneDeep(res.data))
//     res = unserializer.visit(res.data)
//     // console.log("Got unserialized ", res)
//   }
//   return res
// }

export async function get_columnstore_blocks_data(
  pipe_id,
  poid,
  blocks_coords_list,
  block_dimensions,
  sort
) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log("Not calling", project_id, file_id)
    res = { is_instantiated: false }
  } else {
    const params = {
      params: {
        payload: { blocks_coords_list, block_dimensions, sort },
      },
    }
    res = await api.get(
      `/api/projects/${pipe_id}/pipe/${poid}/columnstore/blocksdata`,
      params
    )
    // console.log("Got raw JSON ", _.cloneDeep(res.data))
    res = unserializer.visit(res.data)
    // console.log("Got unserialized ", res)
  }
  return res
}

export async function columnstore_toggle_check_filter_element(
  pipe_id,
  poid,
  column_name,
  elt_index
) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log('In subscription')
    res = { is_instantiated: false }
  } else {
    // const params = {
    //   params: {
    //     payload: { column_name, search, elt_index },
    //   },
    // }

    const ndata = serializer.visit({ column_name, elt_index })
    res = await api.post(
      `/api/projects/${pipe_id}/pipe/${poid}/columnstore/togglecheckfilterelement`,
      ndata
    )
    res = unserializer.visit(res.data)
  }
  return res
}

export async function columnstore_select_all_filter(
  pipe_id,
  poid,
  column_name,
  search,
  is_select_all
) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log('In subscription')
    res = { is_instantiated: false }
  } else {
    // const params = {
    //   params: {
    //     payload: { column_name, search, elt_index },
    //   },
    // }

    const ndata = serializer.visit({ column_name, search, is_select_all })
    res = await api.post(
      `/api/projects/${pipe_id}/pipe/${poid}/columnstore/selectallfilter`,
      ndata
    )
    res = unserializer.visit(res.data)
  }
  return res
}

export async function get_columnstore_column_search_results(
  pipe_id,
  poid,
  column_name,
  search,
  range
) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log('In subscription')
    res = { is_instantiated: false }
  } else {
    const params = {
      params: {
        payload: { column_name, search, range },
      },
    }
    res = await api.get(
      `/api/projects/${pipe_id}/pipe/${poid}/columnstore/columnsearchresults`,
      params
    )
    res = unserializer.visit(res.data)
  }
  return res
}

export async function get_columnstore_column_search_results_length(
  pipe_id,
  poid,
  column_name,
  search
) {
  let res
  if (pipe_id == null || poid == null) {
    // console.log('In subscription')
    res = { is_instantiated: false }
  } else {
    const params = {
      params: {
        payload: { column_name, search },
      },
    }

    res = await api.get(
      `/api/projects/${pipe_id}/pipe/${poid}/columnstore/columnsearchresultslength`,
      params
    )
    res = unserializer.visit(res.data)
  }
  return res
}

// *****************************************************************************

// export async function get_aggregation_automatic_relations(
//   pipe_id,
//   tables_list
// ) {
//   let res
//   if (pipe_id == null) {
//     // console.log('Not calling', project_id, table_id)
//     res = { is_instantiated: false }
//   } else {
//     const params = {
//       params: { payload: { tables_list } },
//     }
//     // console.log(params)
//     res = await api.get(
//       `/api/projects/${pipe_id}/aggregation_automatic_relations`,
//       params
//     )
//     // console.log('Got raw JSON ', _.cloneDeep(res.data))
//     res = unserializer.visit(res.data)
//     // console.log("Got unserialized ", res)
//   }
//   return res
// }

// *****************************************************************************

export async function filesystem_listdir(directory) {
  const params = {
    params: { directory: JSON.stringify(directory) },
  }
  let res = await api.get('/api/filesystem/listdir', params)
  // console.log("Got raw JSON ", _.cloneDeep(res.data))
  res = unserializer.visit(res.data)
  // console.log("Got unserialized ", res)
  return res
}

export async function filesystem_mkdir(directory, folder_name) {
  // const params = {
  //   params: {
  //     payload: { folder_name, path },
  //   },
  // }
  const ndata = serializer.visit({ directory, folder_name })
  let res = await api.put('/api/filesystem/mkdir', ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function filesystem_rename(directory, destination, source) {
  const ndata = serializer.visit({ directory, destination, source })
  let res = await api.put('/api/filesystem/rename', ndata)
  res = unserializer.visit(res.data)
  return res
}

export async function filesystem_remove(directory, entry) {
  const ndata = serializer.visit({ directory, entry })
  let res = await api.put('/api/filesystem/remove', ndata)
  res = unserializer.visit(res.data)
  return res
}
